<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">{{"vizualizar_administrador.visualizar" | translate}}</h2>
    </div>

    <br />
  </div>
  <app-power-bi-embed
    *ngIf="renderizarReporte"
    [embedUrl]="embedUrl"
    [embebedToken]="embedToken"
    [reportId]="reportId"
    [isMobile]="true"
    [heigth]="'650px'"
    [groupId]="groupId"
    [accessToken]="accessToken">
  </app-power-bi-embed>

  <div class="row align-items-center descargar-tablas">
    <div class="col-12 col-md-3">
      <span class="descargar-tablas__titulo">{{"vizualizar_administrador.informacion_descargar" | translate}}</span>
    </div>
    <div class="col-12 col-md-3">{{"vizualizar_administrador.informacion_asociada" | translate}}</div>
    <div class="col-12 col-md-3">
      <select class="form-select" [(ngModel)]="selectedYear">
        <option *ngFor="let year of yearsFilter" [value]="year">
          {{ year }}
        </option>
      </select>
    </div>
    <div class="col-12 col-md-3">
      <button class="btn-govco outline-btn-govco" 
      (click)="downloadExcel()"
      aria-label="Descargar excel">{{"vizualizar_administrador.descargar" | translate}}</button>
    </div>
  </div>
</div>
